export default "__VITE_ASSET__eb36c044__"